export const messages = {
    successMessage: 'Your account has been created successfully and redirected within 5 sec',
    passwordMessage: 'Your password has been updated successfully',
    profileMessage: 'Your name has been updated successfully'
}
